import usersAPISlice from 'api/users/usersAPISlice';
import { clearOpenedCharityId } from 'common/storage/openedCharityStorage';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { DONATIONS_PATH } from 'src/core/paths/paths';

import { isCharityMismatchError } from './utils/isCharityMismatchError';

const RequireOpenedCharityAccount = () => {
  const { error, isLoading } = usersAPISlice.endpoints.getCurrentUser.useQuery();
  const isCharityMismatch = isCharityMismatchError(error);

  useEffect(() => {
    if (!isCharityMismatch) {
      return;
    }
    clearOpenedCharityId();
    window.location.replace(DONATIONS_PATH);
  }, [isCharityMismatch]);

  if (isLoading || isCharityMismatch) {
    return null;
  }
  return <Outlet />;
};

export default RequireOpenedCharityAccount;
